<div class="row g-4" style="display: flex; justify-content: center">
  <div
    *ngFor="let item of contactCards"
    class="col-lg-4 col-md-6 wow fadeInUp"
    data-wow-delay="0.1s"
  >
    <div class="team-item position-relative">
      <img
        class="img-fluid rounded-circle w-75"
        [src]="item.image || ''"
        [alt]="item.name"
      />
      <!--
        dir is set dynamically so Arabic text gets RTL layout automatically.
        For French/English the browser default (ltr) applies.
        If you drive lang/dir from a service, replace the ternary with that value.
      -->
      <div
        class="team-text"
        [attr.dir]="item.lang === 'ar' ? 'rtl' : 'ltr'"
        [attr.lang]="item.lang || null"
      >
        <h3>{{ item.name }}</h3>
        <p>{{ item.job }}</p>
      </div>
    </div>
  </div>

  <!-- Pagination -->
  <nav aria-label="Page navigation example">
    <ul class="pagination justify-content-center">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a
          class="page-link"
          role="button"
          (click)="changePage(currentPage - 1)"
        >
          {{ "previous" | translate }}
        </a>
      </li>
      <li
        class="page-item"
        *ngFor="let page of totalPagesArray"
        [class.active]="currentPage === page"
      >
        <a class="page-link" role="button" (click)="changePage(page)">{{
          page
        }}</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a
          class="page-link"
          role="button"
          (click)="changePage(currentPage + 1)"
        >
          {{ "next" | translate }}
        </a>
      </li>
    </ul>
  </nav>
</div>
